import React, { useEffect, useState } from 'react';

/* MUI */
import { Typography, Grid } from '@mui/material';

/* TYPES */
import {
  Property,
  Unit,
  useThermostatScheduleTemplateDetailQuery,
} from '../../../../../types/generated-types';

/* COMPONENTS */
import { ThermostatScheduleTemplateRowData } from '../../../devices/residential-devices/thermostat/components/schedule/thermostat-schedule';
import { ThermostatScheduleTemplateDetail } from '../../../devices/residential-devices/thermostat/components/schedule/thermostat-schedule-template-detail';

interface ViewUnitScheduleTemplateProps {
  unit?: Partial<Unit>;
  property?: Partial<Property>;
}

export function ViewUnitScheduleTemplate(props: ViewUnitScheduleTemplateProps) {
  /* State */
  const { unit } = props;
  const [template, setTemplate] = useState<ThermostatScheduleTemplateRowData>();

  /* Data */
  const {
    data: templateData,
    loading: templateDataLoading,
    error: templateDataError,
  } = useThermostatScheduleTemplateDetailQuery({
    variables: { id: unit?.thermostatScheduleTemplateId ?? '' },
    fetchPolicy: 'network-only',
  });

  /* HANDLERS */

  /* Property Schedule Template List */
  useEffect(() => {
    if (templateData?.thermostatScheduleTemplateById) {
      setTemplate(templateData.thermostatScheduleTemplateById);
    }
  }, [templateData]);

  return (
    <div>
      {templateDataLoading ? null : template ? (
        <Grid container>
          <Grid item xs={12}>
            <Typography sx={{ textAlign: 'center', margin: '20px 0px' }}>
              Using Schedule Template: {template.name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ThermostatScheduleTemplateDetail template={template} />
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <Typography sx={{ textAlign: 'center', margin: '20px 0px' }}>
              No Active Schedule Template
            </Typography>
          </Grid>
        </Grid>
      )}
    </div>
  );
}
